import axiosWrapper from '../../../helpers/axiosWrapper';
import { encodeUrlQueryData } from '../../../helpers/utils';
import transformSmartBusRequest from '../transformRequest/transformSmartBusRequest';

export function buildInterlink({ id, baseUrl, pageType, siteEdition }: $TSFixMe) {
  const query = encodeUrlQueryData({
    orig: id,
    dest: id,
    tc: pageType,
    edition: siteEdition
  });
  return `${baseUrl}/redirect?${query}`;
}

type IntegrationOptions = {
  meta: $TSFixMe;
  integrationSettings: $TSFixMe;
  pageContext: $TSFixMe;
};

type DeepLinkOptions = {
  baseUrl: string;
  siteEdition: string;
  station: string;
};

export function deepLink({ baseUrl, siteEdition, station }: DeepLinkOptions) {
  const query = {
    orig: station,
    dest: station,
    tc: 'ta',
    edition: siteEdition
  };
  return `${baseUrl}/redirect?${encodeUrlQueryData(query)}`;
}

type LocationsRequestOptions = {
  locationSettings: $TSFixMe;
  options: $TSFixMe;
} & IntegrationOptions;

export const requestLocations = ({
  locationSettings,
  options,
  meta,
  integrationSettings,
  pageContext
}: LocationsRequestOptions): Promise<$TSFixMe> =>
  axiosWrapper(
    {
      method: locationSettings.method,
      url: locationSettings.endPoint,
      headers: { ...locationSettings.headers },
      data: options
    },
    { resource: 'INTEGRATION__BUSDIRECTORY__LOCATIONS', meta, integrationSettings, pageContext }
  );

type RouteRequestOptions = {
  mapBoxSettings: $TSFixMe;
  start: $TSFixMe;
  end: $TSFixMe;
} & IntegrationOptions;

export function requestRoute({
  mapBoxSettings,
  start,
  end,
  meta,
  integrationSettings,
  pageContext
}: RouteRequestOptions): Promise<$TSFixMe> {
  // API Documentation
  // https://docs.mapbox.com/api/navigation/
  const query = encodeUrlQueryData({
    steps: mapBoxSettings.steps,
    geometries: mapBoxSettings.geometries,
    overview: mapBoxSettings.overview,
    access_token: mapBoxSettings.token
  });
  return axiosWrapper(
    {
      method: 'get',
      url: `${mapBoxSettings.endPoint}${start.longitude},${start.latitude};${end.longitude},${end.latitude}?${query}`
    },
    { resource: 'INTEGRATION__BUSDIRECTORY__ROUTE', meta, integrationSettings, pageContext }
  );
}

type StationsRequestOptions = {
  method: string;
  endPoint: string;
  headers: $TSFixMe;
  options: $TSFixMe;
} & IntegrationOptions;

export const requestStations = ({
  method,
  endPoint,
  headers,
  options,
  meta,
  integrationSettings,
  pageContext
}: StationsRequestOptions): Promise<$TSFixMe> =>
  axiosWrapper(
    {
      method,
      url: endPoint,
      headers,
      data: transformSmartBusRequest(options)
    },
    { resource: 'INTEGRATION__BUSDIRECTORY__STATIONS', meta, integrationSettings, pageContext }
  );
